import React, { createContext, useContext, ReactNode } from 'react';
import { usePointsState } from '../hooks/usePointsState';
import { PointsBalance, PointTransaction, PointsCostInfo } from '../services/pointsService';

export interface PointsContextType {
  // State
  balance: PointsBalance | null;
  recentTransactions: PointTransaction[];
  isLoading: boolean;
  isEnabled: boolean;
  planType: 'points' | 'unlimited' | 'traditional' | null;
  error: string | null;
  
  // Actions
  refreshBalance: () => Promise<void>;
  refreshTransactions: () => Promise<void>;
  checkCost: (featureType: string, amount?: number) => Promise<PointsCostInfo | null>;
  clearError: () => void;
}

const PointsContext = createContext<PointsContextType | undefined>(undefined);

export const usePoints = () => {
  const context = useContext(PointsContext);
  if (context === undefined) {
    throw new Error('usePoints must be used within a PointsProvider');
  }
  return context;
};

interface PointsProviderProps {
  children: ReactNode;
}

export const PointsProvider: React.FC<PointsProviderProps> = ({ children }) => {
  const pointsState = usePointsState();

  return (
    <PointsContext.Provider value={pointsState}>
      {children}
    </PointsContext.Provider>
  );
};
